module.exports = "/images/Book_Now.png?bd0712daf92b9257c37d3a5ce87f0167";